import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import moment from 'moment'
import Hashids from 'hashids';

import { 
  tryToFetchMembersByTeam,
  tryToResendInvite,
  tryToEditMember,
  tryToRemoveMemberFromFirm,
  tryToRemoveMemberFromEnterprise,
} from '../../actions/actions.export.js';

import Button from '../Button/Button.js'
import CustomSelect from '../CustomSelect/CustomSelect.js'
import CustomField from '../CustomField/CustomField.js'
import Checkbox from '../Checkbox/Checkbox.js'
import Tags from '../Tags/Tags.js'

import canI from '../../canI.js';

const pf_config = require('../../pf_config.json');
const hashids = new Hashids('k100p');

class TeamSettingsMembersTable extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);

    this.state = {
      pageSize: 10,
      currentPage: 0,
      searchMembers: "",
      editingMember: false,
      roles: [
        {
          label: "Member",
          value: "member"
        },
        {
          label: "Admin",
          value: "admin"
        }
      ]
    }
  }

  componentWillMount(){
    const { dispatch, memberManager } = this.props;
    if(!memberManager.tryingToFetchMembersByTeam){
      dispatch(tryToFetchMembersByTeam({
        id: this.props.id
      }));
    }
  }

  render(){
    const { dispatch, team, memberManager, user } = this.props; 
    const state = this.state;

    if(!team.cache[this.props.id] || memberManager.tryingToFetchMembersByTeam || !memberManager.cache[this.props.id]) return <i className="fal fa-spinner-third fa-spin fa-2x"/>

    let thisTeam = team.cache[this.props.id];
    let savedMembers = memberManager.cache[this.props.id];

    if(this.state.editingMember){
      let m = this.state.editingMember;

      let og_member = savedMembers.find(d => d.id == m.id) || {};
      let currentRole = (og_member  || {}).role;
      let currentTags = (og_member || {}).tags || [];
      let stillOnTheTeam = og_member;
      let currentAdminOnlyStatus =(og_member  || {}).admin_only;

      return <div>
        <Button
          color="grey"
          display={<span><i className="fas fa-angle-left"/> Back to Manage Access</span>}
          onClick={()=>{
            this.setState({
              editingMember: false
            })
          }}
        />
        <hr/>
        {
          !stillOnTheTeam &&
          <p className="lead text-danger">
            This member has been removed.
          </p>
        }
        {
          m.user ? 
          <div>
            <h3 className="text-700">{m.user && m.user.display_name || "n/a"}</h3>
            <p className="lead">
              {m.user && m.user.email || m.invite_sent_to}
            </p>
          </div>
          :
          <div>
            Invite sent to:
            <h3 className="text-700">{m.invite_sent_to}</h3>
            <p className="lead">
              This member has not yet accepted their invitation.<br/>
              <small>Invite sent on {moment(m.created_on).format("MMMM d, YYYY")}</small>
            </p>
            <Button
              display="Resend Invitation Email"
              disabled={!stillOnTheTeam}
              thinking={memberManager.tryingToResendInvite}
              failed={memberManager.failedToResendInvite}
              successful={memberManager.successfullyResentInvite}
              onClick={()=>{
                dispatch(tryToResendInvite({id: m.id}))
              }}
              />

          </div>
        }

        <hr/>
        {
          this.state.editingMember.user_id &&
          <div>
            <div className="large-margin-bottom">
              <CustomSelect
                name="Role"
                label="Role"
                options={this.state.roles}
                disabled={!stillOnTheTeam || this.state.editingMember.user_id === user.id}
                value={m.role}
                onChange={(v)=>{ 
                  let member = this.state.editingMember;
                  member.role = v;
                  this.setState({editingMember: member});
                }}
                placeholder="What privileges should this member have?"
                description={
                  this.state.editingMember.role === "member" ? <span><strong>Members</strong> can access, create, and copy patterns.</span> :
                  this.state.editingMember.role === "admin" ? <span><strong>Admins</strong> can make changes to the team's billing information, edit member access & roles, change settings, and make changes to (including deletion) any patterns - in addition to member priviliges.</span> : ""
                }
                />
            </div>
            {
              m.role === "admin" &&
              <div className="flex-split small-padding">
                <p className="text-thin-line-height">
                  <small className={og_member.admin_only ? "translucent" : ""}>
                    <strong>Admin-Only</strong>: This individual only needs access to settings and does not require a license. Once enabled, this cannot be turned off for this member without deleting and reinviting them to the firm. 
                  </small>
                </p>
                <p className="text-large-switch">
                  <Checkbox 
                    large={true} 
                    disabled={og_member.admin_only}
                    switch={true} 
                    value={this.state.editingMember.admin_only} 
                    onToggle={(v) => { 
                      let member = this.state.editingMember;  
                      member.admin_only = v;
                      this.setState({editingMember: member});
                    }}/>
                </p>
              </div>
            }
          </div>
        }
        <div className="row-push-down-extra">
          {
            canI(user, team, 'office_labels', team.current) && <div className="tool-left-menu-margin-bottom tool-left-menu-group-item tool-left-menu-group-item-left">
              <Tags 
                value={m.tags || []}
                suggestions={memberManager.tagList[m.team_id]} 
                onChange={(e) => {
                  let member = this.state.editingMember;
                  member.tags = e;
                  this.setState({editingMember: member});
                }}
                placeholder="Add tags to automatically label this member's patterns by office, team, or region..."
                />
            </div>
          }
        </div>

        <div className="flex-split row-push-down">
          <div className="list-left">
            <Button
              color="danger"
              display={thisTeam.isEnterprise ? "Delete Member" : "Remove Member"}
              disabled={!stillOnTheTeam || this.state.editingMember.user_id === user.id}
              thinking={memberManager.tryingToRemoveMember}
              failed={memberManager.failedToRemoveMember}
              successful={memberManager.successfullyRemovedMember}
              onClick={()=>{
                if(window.confirm("Are you sure you want to remove this member?")){

                  if(thisTeam.isEnterprise){
                    dispatch(tryToRemoveMemberFromEnterprise({
                      id: this.state.editingMember.id
                    }))
                  } else {
                    dispatch(tryToRemoveMemberFromFirm({
                      id: this.state.editingMember.id
                    }))
                  }
                }
              }}
            />
          </div>
          <div className="list-right">
          
            <Button
              color="grey"
              display="Cancel"
              disabled={!stillOnTheTeam}
              onClick={()=>{
                this.setState({
                  editingMember: false
                })
              }}
            />

            <Button
              color="success"
              display="Save Changes"
              disabled={!stillOnTheTeam || (m.role === currentRole && (m.tags || []).join("") === currentTags.join("") && m.admin_only == currentAdminOnlyStatus) }
              thinking={memberManager.tryingToEditMember}
              failed={memberManager.failedToEditMember}
              successful={memberManager.successfullyEditedMember}
              onClick={()=>{
                dispatch(tryToEditMember({
                  id: this.state.editingMember.id,
                  role: this.state.editingMember.role,
                  admin_only: this.state.editingMember.admin_only,
                  tags: this.state.editingMember.tags || [],
                  team_id: this.props.id
                }))
              }}
            />
          </div>
        </div>
        {
          thisTeam.isEnterprise &&
          <p className="text-danger text-small">
            {
              this.state.editingMember.user_id === user.id ? 
              "You can't remove yourself from an enterprise."
              :
              "Deleting this member will require them to create a new Pattycake account and re-verify their email address prior to accessing this Enterprise again."
            }
          </p>
        }
      </div>
    }

    let counter = 0;

    let members = memberManager.cache[this.props.id];
    if(this.state.searchMembers){
      members = members.filter(m => (m.user && m.user.email || m.invite_sent_to).toLowerCase().indexOf(this.state.searchMembers.toLowerCase()) > -1 || (m.user && m.user.display_name || "").toLowerCase().indexOf(this.state.searchMembers.toLowerCase()) > -1 )
    }

    let seatsThatCount = memberManager.cache[this.props.id].filter(m => !m.admin_only).length;
    let emptyseats = thisTeam.seats - seatsThatCount;


    return (
      <div>
        <h4 className="text-700">{this.state.searchMembers && "Found "}{members.length} Member{members.length > 1 && "s"} {this.state.searchMembers && <small className="translucent">(out of {memberManager.cache[this.props.id].length})</small>}</h4>
        <div className="flex-split">
          <div className="flex-grow-1 small-margin-right">
            <CustomField
              name="searchMembers"
              type='text'
              placeholder='search members by email or name...'
              inline={true}
              timeout={250}
              value={this.state.searchMembers}
              onChange={(e)=> { 
                this.setState({
                  searchMembers: e,
                  currentPage: 0
                }) 
              }}
              form={false}
              />
          </div>
          <Button
            display="Clear Search"
            color="grey"
            onClick={()=>{
              this.setState({
                searchMembers: ""
              })
            }}
            />
        </div>
        <br/>

        {
          members.length > 0 ?
          <div>
            <div style={{minHeight: (members.length > this.state.pageSize ? 425 : undefined)}}>
              <table className="table table-striped member-table">
                <thead>
                  <tr>
                    <th width="40%">name</th>
                    <th width="40%">email</th>
                    <th width="100px">role</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    members.map((m,i)=>{

                      let email = m.user && m.user.email || m.invite_sent_to;
                      let name = m.user ? (m.user && m.user.display_name) : <small className="translucent">not yet accepted</small>;

                      if(m.user_id === user.id) name = "you";

                      if(counter >= this.state.pageSize * this.state.currentPage && counter < this.state.pageSize * (this.state.currentPage + 1)){
                        counter++;
                        return <tr key={i} className="tr-clickable" onClick={()=>{
                            this.setState({
                              editingMember: JSON.parse(JSON.stringify(m))
                            })
                          }}>
                          <td>{name}&nbsp;</td>
                          <td><small>{email}</small></td>
                          <td width="100px"><nobr><small>{m.admin_only ? "admin-only" : m.role}</small></nobr></td>
                        </tr>
                      }

                      counter++;

                      return;
                    })
                  }
                </tbody>
              </table>
            </div>
            {
              members.length > this.state.pageSize &&
              <div className="list-right">
                <small>Showing {this.state.currentPage * this.state.pageSize + 1} to { ((this.state.currentPage + 1) * this.state.pageSize) > members.length ? members.length : ((this.state.currentPage + 1) * this.state.pageSize) } of {members.length}</small>
                <Button
                  size="small"
                  display="Previous Page"
                  disabled={this.state.currentPage == 0}
                  onClick={()=>{
                    this.setState({
                      currentPage: this.state.currentPage - 1
                    })
                  }}
                />
                <Button
                  size="small"
                  display="Next Page"
                  disabled={(this.state.currentPage + 1) * this.state.pageSize >= members.length}
                  onClick={()=>{
                    this.setState({
                      currentPage: this.state.currentPage + 1
                    })
                  }}
                />
              </div>
            }
          </div>
          :
          <span>Can't find anyone based on that search.</span>
        }

        {
          (thisTeam.isFirm && !thisTeam.isEnterprise) &&
          <div>
            <p className={seatsThatCount > thisTeam.seats ? "text-danger" : ""}>You are currently using <strong>{seatsThatCount}</strong> out of <strong>{thisTeam.seats}</strong> seats on your current license.</p>              
            <p>To add more seats, visit the <Link to={"/settings/firm/" + hashids.encode(thisTeam.id) + '/billing' }>Billing Portal</Link> and update your plan to the desired quantity.</p>
          </div>
        }

      </div>
    )
  }
}
const mapStateToProps = (state) => {
  const { team, memberManager, user } = state;

  return {
    team, memberManager, user
  }
}

export default connect(mapStateToProps)(TeamSettingsMembersTable);



// WEBPACK FOOTER //
// ./src/components/TeamSettingsMembersTable/TeamSettingsMembersTable.js